const messages: Record<string, string> = {
	'vehicleRegistrationDocument.title': 'Vehicle registration document',
	'vehicleRegistrationDocument.description':
		'Upload clear photos of the requested sides of the vehicle registration document.',
	'vehicleRegistrationDocument.RegistrationDocument.title': 'Front of the registration document',
	'vehicleRegistrationDocument.RegistrationDocument.description':
		'Take a clear photo of the front of the registration document.',
	'vehicleRegistrationDocument.RegistrationDocument.headline': 'Front of the registration document',
	'vehicleRegistrationDocument.RegistrationDocument.exampleModalTitle':
		'Front of the registration document - example',
	'vehicleRegistrationDocument.RegistrationDocument.validationRequired':
		'Front of the registration document',
	'vehicleRegistrationDocument.RegistrationDocumentInside.title':
		'Back of the registration document',
	'vehicleRegistrationDocument.RegistrationDocumentInside.description':
		'Take a clear photo of the back of the registration document.',
	'vehicleRegistrationDocument.RegistrationDocumentInside.headline':
		'Back of the registration document',
	'vehicleRegistrationDocument.RegistrationDocumentInside.exampleModalTitle':
		'Back of the registration document - example',
	'vehicleRegistrationDocument.RegistrationDocumentInside.validationRequired':
		'Back of the registration document',
	'vehicleRegistrationDocument.validationHeadline': 'Missing photos',
	'vehicleRegistrationDocument.validationDescription': 'Please add the following photos:',
	'landing.stepDescription.vehicleRegistrationDocument':
		'Take photos of the vehicle registration document',
	'review.stepDescription.vehicleRegistrationDocument': 'Vehicle registration document',
};

export default messages;
